import { BoxV2 as Box, Flex } from 'portal-commons';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Section, SectionTitle } from './atoms';
import { CampaignDetail, Mno } from '@/apis/core';
import { selectMnos } from '@/shared_elements/selectors';

interface TargetNetworkSectionProps {
  campaign: CampaignDetail;
}

export const TargetNetworksSection: FC<TargetNetworkSectionProps> = ({
  campaign,
}) => {
  const mnos = useSelector(selectMnos);
  const mnoMapping = useMemo(
    () =>
      mnos.reduce((accumulator, mno) => {
        accumulator[mno.networkId] = mno;
        return accumulator;
      }, {} as Record<string, Mno>),
    [mnos]
  );

  return (
    <Section>
      <SectionTitle>Target Networks</SectionTitle>
      <Flex sx={{ gap: 'xs', flexWrap: 'wrap' }}>
        {(campaign.targetMNOs || []).map((mno) => (
          <Box
            sx={{
              p: '6px 16px',
              borderRadius: '1000px',
              color: '#FFF',
              background: 't.black50',
              fontWeight: 400,
              fontSize: 'H200',
            }}
          >
            {mnoMapping[mno]?.displayName ?? mno}
          </Box>
        ))}
      </Flex>
    </Section>
  );
};

export default TargetNetworksSection;
